import { action, createRequestTypes } from './base';

export const cnActionTypes = {
  GET_CN: createRequestTypes('GET_CN'),
  GET_CN_BY_ID: createRequestTypes('GET_CN_BY_ID'),
  CREATE_CN: createRequestTypes('CREATE_CN'),
  UPDATE_CN: createRequestTypes('UPDATE_CN'),
  UPDATE_STATUS_CN: createRequestTypes('UPDATE_STATUS_CN'),
  UPDATE_CN_WORKFLOW_STEP: createRequestTypes('UPDATE_CN_WORKFLOW_STEP'),
  DELETE_CN: createRequestTypes('DELETE_CN'),
  LINK_PAYMENT_TO_CN: createRequestTypes('LINK_PAYMENT_TO_CN'),
};

/**
 * @param payload
 * @param getPoPendingApprovalLoading
 * @param tenantId
 * @param cnId
 * @param cnEntityId
 * @param cnEntityType
 * @param status
 * @param limit
 * @param page
 * @param tenantSellerId
 * @param selectedEntityType
 * @param callback
 */
class CNActions {
  /**
   * @param {*} orgId
   * @param {*} cnId
   * @param {*} page
   * @param tenantId
   * @param customerId
   * @param searchKeyword
   * @param {*} limit
   * @return
   */
    getCN = (tenantId, cnId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, accountManagerIds, docType, is_list) => action(cnActionTypes.GET_CN.REQUEST, {
      tenantId, cnId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, accountManagerIds, docType, is_list
    })

    /**
     *
     * @param {*} getCNLoading
     * @return
     */
     getCNLoading = (getCNLoading) => action(cnActionTypes.GET_CN.LOADING, {
       getCNLoading,
     })

     /**
      * @return
      * @param cns
      * @param creditNotes
      * @param customFields
      */
     getCNSuccess = (creditNotes) => action(cnActionTypes.GET_CN.SUCCESS, {
       creditNotes,
     })

     /**
      * @param {*} tenantId
      * @param orgId
      * @param {*} cnId
      * @return
      */
     getCNById = (tenantId, cnId, docType) => action(cnActionTypes.GET_CN_BY_ID.REQUEST, {
       tenantId, cnId, docType,
     })

     /**
      *
      * @param {*} getCNByIdLoading
      * @return
      */
     getCNByIdLoading = (getCNByIdLoading) => action(cnActionTypes.GET_CN_BY_ID.LOADING, {
       getCNByIdLoading,
     })

     /**
      * @return
      * @param selectedCN
      * @param cnData
      */
      getCNByIdSuccess = (selectedCN) => action(cnActionTypes.GET_CN_BY_ID.SUCCESS, {
        selectedCN,
      })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createCN = (payload, callback) => action(cnActionTypes.CREATE_CN.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} createCNLoading
     * @return
     */
    createCNLoading = (createCNLoading) => action(cnActionTypes.CREATE_CN.LOADING, {
      createCNLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
     updateCN = (payload, callback) => action(cnActionTypes.UPDATE_CN.REQUEST, {
       payload,
       callback,
     })

     /**
      *
      * @param {*} updateCNLoading
      * @return
      */
     updateCNLoading = (updateCNLoading) => action(cnActionTypes.UPDATE_CN.LOADING, {
       updateCNLoading,
     })

    /**
     * @param tenantId
     * @param cnId
     * @param orgId
     * @param payload
     * @param callback
     * @return {{type: *}}
     */
    updateCNStatus = (payload, callback) => action(cnActionTypes.UPDATE_STATUS_CN.REQUEST, {
      payload, callback,
    })

    /**
     * @param updateCNStatusLoading
     * @return {{type: *}}
     */
     updateCNStatusLoading = (updateCNStatusLoading) => action(cnActionTypes.UPDATE_STATUS_CN.LOADING, {
       updateCNStatusLoading,
     })

     /**
      * @param tenantId
      * @param cnId
      * @param orgId
      * @param payload
      * @param callback
      * @return {{type: *}}
      */
    deleteCN = (payload, callback) => action(cnActionTypes.DELETE_CN.REQUEST, {
      payload, callback,
    })

    /**
     * @param deleteCNLoading
     * @return {{type: *}}
     */
     deleteCNLoading = (deleteCNLoading) => action(cnActionTypes.DELETE_CN.LOADING, {
       deleteCNLoading,
     })

     /**
      * @param tenantId
      * @param cnId
      * @param orgId
      * @param payload
      * @param callback
      * @return {{type: *}}
      */
        updateCNWorkflowStep = (payload, callback) => action(cnActionTypes.UPDATE_CN_WORKFLOW_STEP.REQUEST, {
          payload, callback,
        })

  /**
   * @param updateCNStatusLoading
   * @param updateCNWorkflowStepLoading
   * @param deleteCNLoading
   * @return {{type: *}}
   */
  updateCNWorkflowStepLoading = (updateCNWorkflowStepLoading) => action(cnActionTypes.UPDATE_CN_WORKFLOW_STEP.LOADING, {
    updateCNWorkflowStepLoading,
  })

  linkPaymentToCn = (payload, callback) => action(cnActionTypes.LINK_PAYMENT_TO_CN.REQUEST, {
    payload, callback,
  })

  linkPaymentToCnLoading = (linkPaymentToCnLoading) => action(cnActionTypes.LINK_PAYMENT_TO_CN.LOADING, {
    linkPaymentToCnLoading,
  })
}

export default new CNActions();
